// src/components/auth/pendingSignup.js
// Signup no longer logs anyone in: the email has to be confirmed first (backend email_gate.py).
// These keep what the signup knew until the first login: the address to confirm (prefills the login
// page) and a paid plan to send to checkout.
const EMAIL = 'pendingVerifyEmail';
const CHECKOUT = 'pendingCheckout';

const get = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
const set = (k, v) => { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch { /* private mode */ } };

export const readPendingVerifyEmail = () => get(EMAIL);
export const rememberPendingVerifyEmail = (email) => set(EMAIL, email);
export const clearPendingVerifyEmail = () => set(EMAIL, null);

export function rememberPendingCheckout(body) { set(CHECKOUT, JSON.stringify(body)); }
export function takePendingCheckout() {
  const raw = get(CHECKOUT);
  set(CHECKOUT, null);
  try { return raw ? JSON.parse(raw) : null; } catch { return null; }
}

// An older session (or anything that slipped through) whose account isn't confirmed: drop it so the
// site treats the visitor as a guest. Arena pages simply reload as a guest; elsewhere go to log in.
const GUEST_OK = /^\/(practice|arena|duel|duels|challenge)(\/|$)/;
export function dropUnverifiedSession() {
  if (!get('token')) return;
  const email = get('userEmail');
  if (email) set(EMAIL, email);
  ['token', 'userName', 'userEmail', 'userRole', 'trialEnd'].forEach((k) => set(k, null));
  const path = window.location.pathname;
  if (GUEST_OK.test(path)) { window.location.reload(); return; }
  if (!path.startsWith('/login')) window.location.href = `/login?verify=1${email ? `&email=${encodeURIComponent(email)}` : ''}`;
}
